import { getI18n } from 'react-i18next';
import { Store } from 'store/index';
import getEveryItemOutOfStock from './getEveryItemOutOfStock';
import getPersonalisedProduct from './getPersonalisedProduct';
import getPersonalisedProductItem from './getPersonalisedProductItem';
import getSelectedBundleProducts from './getSelectedBundleProducts';

const getPersonalisedButton = (store: Store) => {
  const productItem = getPersonalisedProductItem(store);
  const isEveryItemOutOfStock = getEveryItemOutOfStock(store);
  const product = getPersonalisedProduct(store);
  const selectedBundledProducts = getSelectedBundleProducts(store);
  const bundledProducts = selectedBundledProducts
    .filter((bundledGroup) => bundledGroup.productId > 0)
    .map((bundledGroup) => ({ bgId: bundledGroup.bundleGroupId, pid: bundledGroup.productId }));
  const searchParams = new URLSearchParams('');
  searchParams.append('abstractProductId', String(productItem?.product.abstractProductId));
  searchParams.append('internalUid', productItem?.product.internalUid || '');
  if (bundledProducts.length) {
    searchParams.append('bundledProducts', encodeURIComponent(bundledProducts.toString()));
  }

  const editorLink = `${(product as any)?.mainButtonReferenceUrl}?${searchParams.toString()}`;

  return {
    editorLink,
    buttonLabel: isEveryItemOutOfStock ? getI18n().t('txt_availability_status_unavailable') : product?.mainButtonLabel,
  };
};

export default getPersonalisedButton;
